import { Navigate, useParams } from 'react-router-dom'
import { UserTestChat } from '../widgets/chat/userTestChat.tsx'
import { urls } from '../shared/urls.ts'

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type RouteParams = {
  tag: string
}

export function UserTestPage() {
  const params = useParams<RouteParams>()

  const tag = params.tag ?? null
  if (!tag) {
    return <Navigate to={urls.testMode} />
  }
  return <UserTestChat tag={tag} />
}

